<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="companies"
			:loading="loading"
			class="elevation-1"
			:mobile-breakpoint="0"
			:search="search"
		>
			<template #item.action="{item}">
				<td>
					<edit-btn
						class="mx-2 my-1"
						@click="onEdit(item)"
					/>
					<remove-btn @remove="doRemove(item)" class="mx-2 my-1" />
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { types } from "src/store/modules/Company.module";
import FilterAble from "src/mixins/FilterAble";

export default {
	name: "CompaniesTable",
	components: {},
	props: [],
	mixins: [new FilterAble(types)],
	data () {
		return {
			loading: false,
			headers: [
				{ text: "שם המרכז", value: "name" },
				{ text: "מסלול", value: "current_payment_tokens.decode.plan" },
				{ text: "מספר משחקים", value: "games_in_plan" },
				{ text: "תאריך תפוגת מנוי", value: "current_payment_tokens.expire_at" },
				{ text: "פעולות", value: "action" },
			],
			search: null,
			showDialog: false,
		};
	},
	computed: {
		companies () {
			return this.$store.state.CompanyModule.companies;
		},
	},
	methods: {
		onEdit (company) {
			this.$emit("edit", company);
		},
		doRemove (company) {
			this.$store.dispatch(types.REMOVE, company);
		},
	},
};
</script>

<style>

</style>
